export function isDebugCaptureEnabled(): boolean {
  return process.env.NEXT_PUBLIC_NODE_ENV !== "PROD";
}

/** Phase 2 — Cursor handoff dialog after capture. Also accepts legacy CLICKUP flag. */
export function isDebugCaptureHandoffEnabled(): boolean {
  if (!isDebugCaptureEnabled()) {
    return false;
  }

  if (process.env.NEXT_PUBLIC_DEBUG_CAPTURE_HANDOFF === "false") {
    return false;
  }

  if (process.env.NEXT_PUBLIC_DEBUG_CAPTURE_CLICKUP === "false") {
    return false;
  }

  return true;
}

/** @deprecated use isDebugCaptureHandoffEnabled */
export function isDebugCaptureClickUpEnabled(): boolean {
  return isDebugCaptureHandoffEnabled();
}
